<app-button-list *ngIf="enableAddButton">
    <app-button (clickedEvent)="show()">Add new text component </app-button>
</app-button-list>
<app-table
        *ngIf="searchCriteria"
        [searchCriteria]="searchCriteria"
        [tableName]="tableName"
        [baseUrl]="baseUrl"
        [columns]="columns"
></app-table>